import React from 'react';

export type DescriptionListItem = {
  key: string;
  title: string;
  description: string;
  weight: number;
};

type Props = JSX.IntrinsicElements['ul'] & {
  items: DescriptionListItem[];
};

const DescriptionList: React.FC<Props> = function ({ items, ...props }: Props) {
  return (
    <ul className="pds-mb-0 pds-pl-0" {...props}>
      {items.map((item, i) => (
        <li className="pds-mb-4" key={`${item.title}-${i}`}>
          <div className="pds-text-title-sm">{item.title}:</div>
          <div className="pds-text-title-sm pds-font-normal">{item.description}</div>
        </li>
      ))}
    </ul>
  );
};

export default DescriptionList;
